import React, { useEffect, useRef, useState } from 'react';
import { Spinner } from '../common/Feedback';

/** Camera preview + capture. Only shown when the backend has face scan enabled. */
export default function FaceCapture({ onCapture, busy }) {
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    navigator.mediaDevices
      ?.getUserMedia({ video: { facingMode: 'user', width: 640, height: 480 } })
      .then((stream) => {
        if (!alive) {
          stream.getTracks().forEach((t) => t.stop());
          return;
        }
        streamRef.current = stream;
        if (videoRef.current) videoRef.current.srcObject = stream;
      })
      .catch((e) => setError(e.message || 'Camera not available'));
    return () => {
      alive = false;
      streamRef.current?.getTracks().forEach((t) => t.stop());
    };
  }, []);

  const capture = () => {
    const video = videoRef.current;
    if (!video?.videoWidth) return;
    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);
    canvas.toBlob((blob) => blob && onCapture(blob), 'image/jpeg', 0.9);
  };

  return (
    <div className="dp-face">
      {error ? <p className="dp-cart-warn">{error}</p> : <video ref={videoRef} autoPlay playsInline muted />}
      <button type="button" className="dp-btn" onClick={capture} disabled={busy || Boolean(error)}>
        {busy ? <Spinner small /> : null} Capture & match
      </button>
    </div>
  );
}
